<div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <h1>
                <span jhiTranslate="head-to-head-query.title">MAIN HEAD TO HEAD QUERY</span>&nbsp;
                <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
            </h1>
        </div>
    </div>
    <br>
    <div class="row">
        <div class="col-md-12">
            <div class="card panel-default">
                <div class="card-body">
                    <mat-accordion [multi]="false" displayMode="flat">
                        <mat-expansion-panel [disabled]="step() !== 0" [expanded]="step() === 0" (opened)="setStep(0)" hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title><span jhiTranslate="head-to-head-query.specify.entries.title"></span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <jhi-specify-entries [active]="step() === 0" (next)="nextStep()"></jhi-specify-entries>
                        </mat-expansion-panel>
                        <mat-expansion-panel [disabled]="step() !== 1" [expanded]="step() === 1" (opened)="setStep(1)" hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title><span jhiTranslate="head-to-head-query.select.traits.title"></span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <jhi-select-traits [active]="step() === 1" (back)="prevStep()" (next)="nextStep()"></jhi-select-traits>
                        </mat-expansion-panel>
                        <mat-expansion-panel [disabled]="step() !== 2" [expanded]="step() === 2" (opened)="setStep(2)" hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title><span jhiTranslate="head-to-head-query.select.environments.title"></span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <jhi-select-environments-step [active]="step() === 2" (back)="prevStep()" (next)="nextStep()"></jhi-select-environments-step>
                        </mat-expansion-panel>
                        <mat-expansion-panel [disabled]="step() !== 3" [expanded]="step() === 3" (opened)="setStep(3)" hideToggle>
                            <mat-expansion-panel-header>
                                <mat-panel-title><span jhiTranslate="head-to-head-query.display.results.title"></span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <ng-container *ngIf="step() === 3">
                                <jhi-display-results [active]="step() === 3" (back)="prevStep()"></jhi-display-results>
                            </ng-container>
                        </mat-expansion-panel>
                    </mat-accordion>
                </div>
            </div>
        </div>
    </div>
</div>
